import React, { memo } from 'react';

import { ProfileButton } from './styles';
import { Button, Menu, MenuButton, MenuList, MenuItem, Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { clearStorage } from 'services/storage';
import { getLoggedUser } from 'utils/storage';
import srcPicture from 'assets/profile_picture.png';

const ProfileComp = (): JSX.Element => {
  const history = useHistory();
  const { name } = getLoggedUser();
  function handleLogout() {
    clearStorage();
    clearStorage(true);
    setTimeout(() => {
      history.push('/home');
    }, 1200);
  }

  return (
    <React.Fragment>
      <Menu>
        {({ isOpen }) => (
          <>
            <Flex alignItems="center">
              <div style={{ userSelect: 'none' }}>{name}</div>
              <MenuButton
                isActive={isOpen}
                leftIcon={isOpen ? <FaChevronUp /> : <FaChevronDown />}
                as={Button}
                bgColor="transparent"
                _hover={{ bg: 'transparent' }}
                _active={{ borderStyle: 'outset' }}
                _focus={{ border: 'none' }}
              >
                <ProfileButton>
                  <img src={srcPicture} alt="foto de perfil" />
                </ProfileButton>
              </MenuButton>
            </Flex>
            <MenuList boxShadow=" 0px 5px 10px rgba(0, 0, 0, 0.15)" minWidth="5rem">
              <Flex direction="column" align="flex-end" p="0 1rem">
                <MenuItem
                  display="flex"
                  justifyContent="flex-end"
                  onClick={() => history.push('/changePassword')}
                  color="black"
                  fontWeight="600"
                  _focus={{
                    background: 'white',
                  }}
                >
                  Alterar Senha
                </MenuItem>
                <MenuItem
                  display="flex"
                  justifyContent="flex-end"
                  onClick={handleLogout}
                  color="black"
                  fontWeight="600"
                  _focus={{
                    background: 'white',
                  }}
                >
                  Sair
                </MenuItem>
              </Flex>
            </MenuList>
          </>
        )}
      </Menu>
    </React.Fragment>
  );
};

export const ProfileMenu = memo(ProfileComp);
